import { useLanguageContext } from "../../../../../../context/LanguageContext";
import LabelItemParagraph from "../../paragraph/ParagraphLabelItem";

export default function FieldValuesLabelItem({
  item,
  visitorData,
  printerData,
  fields,
  readOnly,
}) {
  const { translateEntity, translate } = useLanguageContext();

  function getFieldValues() {
    return item.fields
      .map((f) => {
        let field = !(f instanceof Object)
          ? fields?.find((field) => field.id === f) ?? null
          : f;
        return field ? getFieldValue(field) : "";
      })
      .join(" ");
  }

  function getFieldValue(field) {
    const visitorField = visitorData?.fields?.find(
      (f) => parseInt(f.field) === parseInt(field.id)
    );
    if (!visitorField) {
      return "";
    }

    const visitorFieldValue = visitorField.value ?? visitorField.field_option;
    if (!visitorFieldValue) {
      return "";
    }

    switch (field.type) {
      case "boolean":
        return translate(
          `eva.main.general.${visitorFieldValue === "1" ? "yes" : "no"}`
        );
      case "select":
        return translateEntity(
          field.options.find((option) => option.id === visitorFieldValue),
          "label"
        );
      default:
        return visitorFieldValue;
    }
  }

  return (
    <LabelItemParagraph item={item} printerData={printerData}>
      {readOnly
        ? getFieldValues()
        : translate("eva.main.printers.label.item.types.field_values")}
    </LabelItemParagraph>
  );
}
